import React from 'react';
import SocialMediaPopup from '@src/utils/SocialMediaPopup';

const Google = () => <SocialMediaPopup provider="google" />;

export default Google;
